import { Box } from "@mui/material";
import useMSSP from "../../api/hooks/useMSSP";
import InitialScanBanner from "../../components/InitialScanBanner";
import AppPage from "../../components/structure/AppPage";
import CustomDashboard from "./custom_dashboard/CustomDashboard";
import MSSPDashboard from "./MSSPDashboard";

const Dashboard = () => {
  const { isAllTenants, isMSSP } = useMSSP();

  const getTitle = () => {
    if (isMSSP && isAllTenants) return "";

    return "Posture Overview";
  };

  return (
    <AppPage title={getTitle()}>
      <InitialScanBanner />
      {isMSSP && isAllTenants ? (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <MSSPDashboard />
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <CustomDashboard />
        </Box>
      )}
    </AppPage>
  );
};

export default Dashboard;
